import { RouterView, type RouterOptions } from "vue-router";

const names = {
  dustCards: "DustCard.DustCards",
  list: "DustCard.DustCardList",
};

export { names as dustCardRouteNames };

const dustCardRoutes: RouterOptions["routes"] = [
  {
    path: "/dustCard",
    name: names.dustCards,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Cards",
          lookupGroups: [],
        },
        component: () => import("@/views/dustCard/DustCardList.vue"),
      },
    ],
  },
];

export default dustCardRoutes;
